<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="aboutKYPage">
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox">
                        <h2>新聞中心</h2>
                        <div class="mainTitleBox">
                            <h1>深入了解</h1>
                            <h1>我們的發展成就</h1>
                        </div>
                        <p>
                            我們與您分享企業文化、價值觀，期許與您攜手共創美好未來
                        </p>
                    </div>
                </div>
            </div>
            <div
                class="copInfoArea"
                id="copInfoArea">
                <div class="nameBox">
                    <!-- <button
						pButton
						label="最新消息"
						class="news-center-type"
						(click)="changeNewsType(1, $event)"
						[ngClass]="newsType === 1 ? 'selected' : null"></button> -->
                    <button
                        pButton
                        label="新聞"
                        class="news-center-type"
                        (click)="changeNewsType(2, $event)"
                        [ngClass]="newsType === 2 ? 'selected' : null"></button>
                    <button
                        pButton
                        label="電子報"
                        class="news-center-type"
                        (click)="changeNewsType(3, $event)"
                        [ngClass]="newsType === 3 ? 'selected' : null"></button>
                </div>
            </div>

            <!-- ----------------------------------------------------------------------- -->
            <!--                                電子報 + 新聞                              -->
            <!-- ----------------------------------------------------------------------- -->
            <div
                *ngIf="newsType === 1"
                class="teamArea"
                id="teamArea">
                <div class="teamBox">
                    <div
                        *ngFor="let item of newsByPage; index as i"
                        [ngClass]="i === 0 ? 'firstNewsBox' : 'normalNewsBox'">
                        <div
                            *ngIf="i === 0"
                            class="memberBox"
                            (click)="goViewNews(item.TypeEN, item.FileTitle)">
                            <div class="imgBox">
                                <img
                                    [ngStyle]="{
                                        'object-position':
                                            i === 0 &&
                                            item.TypeEN === 'electronic'
                                                ? 'center top'
                                                : 'center'
                                    }"
                                    [src]="item.Image"
                                    alt="" />
                                <div class="firstWordBox">
                                    <div
                                        class="firstWordBoxVital"
                                        [class.dark-text]="item.DarkText"
                                        *ngIf="item.TypeEN === 'news'">
                                        <p class="date">{{ item.Date }}</p>
                                        <p class="type">
                                            <span class="initial">
                                                {{
                                                    item?.Type?.split(' ｜ ')[0]
                                                }}
                                            </span>
                                            ｜
                                            {{ item?.Type?.split(' ｜ ')[1] }}
                                        </p>
                                        <p class="content">
                                            {{ item.Content }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            *ngIf="i !== 0"
                            class="memberBox"
                            (click)="goViewNews(item.TypeEN, item.FileTitle)">
                            <div
                                class="imgBox"
                                [ngClass]="{
                                    'h-100 e-news-img-mobile':
                                        item.TypeEN === 'electronic'
                                }">
                                <img
                                    [src]="item.Image"
                                    alt="" />
                            </div>
                            <div
                                class="vital"
                                *ngIf="item.TypeEN === 'news'">
                                <p class="date">{{ item.Date }}</p>
                                <p class="type">
                                    <span class="initial">
                                        {{ item?.Type?.split(' ｜ ')[0] }}
                                    </span>
                                    ｜
                                    {{ item?.Type?.split(' ｜ ')[1] }}
                                </p>
                                <p class="content">
                                    {{ item.Content }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----------------------------------------------------------------------- -->
            <!--                                   新聞                                   -->
            <!-- ----------------------------------------------------------------------- -->

            <div
                *ngIf="newsType === 2"
                class="teamArea"
                id="teamArea">
                <div class="teamBox">
                    <div
                        *ngFor="let item of newsByPage; index as i"
                        [ngClass]="i === 0 ? 'firstNewsBox' : 'normalNewsBox'">
                        <div
                            *ngIf="i === 0"
                            class="memberBox"
                            (click)="goViewNews(item.TypeEN, item.FileTitle)">
                            <div class="imgBox">
                                <img
                                    [src]="item.Image"
                                    alt="" />
                                <div class="firstWordBox">
                                    <div class="firstWordBoxVital" [class.dark-text]="item.DarkText">
                                        <p class="date">{{ item.Date }}</p>
                                        <p class="type">
                                            <span class="initial">
                                                {{
                                                    item?.Type?.split(' ｜ ')[0]
                                                }}
                                            </span>
                                            ｜
                                            {{ item?.Type?.split(' ｜ ')[1] }}
                                        </p>
                                        <p class="content">
                                            {{ item.Content }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            *ngIf="i !== 0"
                            class="memberBox"
                            (click)="goViewNews(item.TypeEN, item.FileTitle)">
                            <div class="imgBox">
                                <img
                                    [src]="item.Image"
                                    alt="" />
                            </div>
                            <div class="vital">
                                <p class="date">{{ item.Date }}</p>
                                <p class="type">
                                    <span class="initial">
                                        {{ item?.Type?.split(' ｜ ')[0] }}
                                    </span>
                                    ｜
                                    {{ item?.Type?.split(' ｜ ')[1] }}
                                </p>
                                <p class="content">
                                    {{ item.Content }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----------------------------------------------------------------------- -->
            <!--                                   電子報                                 -->
            <!-- ----------------------------------------------------------------------- -->

            <div
                *ngIf="newsType === 3"
                class="teamArea"
                id="teamArea">
                <div class="teamBox">
                    <div
                        *ngFor="let item of newsByPage; index as i"
                        [ngClass]="i === 0 ? 'firstNewsBox' : 'normalNewsBox'">
                        <div
                            *ngIf="i === 0"
                            class="memberBox"
                            (click)="goViewNews(item.TypeEN, item.FileTitle)">
                            <div class="imgBox">
                                <img
                                    [ngStyle]="{
                                        'object-position':
                                            i === 0 ? 'center top' : 'center'
                                    }"
                                    [src]="item.Image"
                                    alt="" />
                                <div class="firstWordBox">
                                    <div
                                        class="firstWordBoxVital"
                                        [class.dark-text]="item.DarkText"
                                        *ngIf="item.TypeEN === 'news'">
                                        <p class="date">{{ item.Date }}</p>
                                        <p class="type">
                                            <span class="initial">
                                                {{
                                                    item?.Type?.split(' ｜ ')[0]
                                                }}
                                            </span>
                                            ｜
                                            {{ item?.Type?.split(' ｜ ')[1] }}
                                        </p>
                                        <p class="content">
                                            {{ item.Content }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            *ngIf="i !== 0"
                            class="memberBox"
                            (click)="goViewNews(item.TypeEN, item.FileTitle)">
                            <div
                                class="imgBox"
                                [ngClass]="{
                                    'h-100 e-news-img-mobile':
                                        item.TypeEN === 'electronic'
                                }">
                                <img
                                    [src]="item.Image"
                                    alt="" />
                            </div>
                            <div
                                class="vital"
                                *ngIf="item.TypeEN === 'news'">
                                <p class="date">{{ item.Date }}</p>
                                <p class="type">
                                    <span class="initial">
                                        {{ item?.Type?.split(' ｜ ')[0] }}
                                    </span>
                                    ｜
                                    {{ item?.Type?.split(' ｜ ')[1] }}
                                </p>
                                <p class="content">
                                    {{ item.Content }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="pageArea"
                *ngIf="news.length">
                <div class="nameBox">
                    <p-paginator
                        #paginator
                        (onPageChange)="getDataByPage($event)"
                        [first]="1"
                        [rows]="8"
                        [totalRecords]="news.length"
                        [showFirstLastIcon]="false"></p-paginator>
                </div>
            </div>

            <app-partnership></app-partnership>
        </div>
    </div>
</div>
<app-footer></app-footer>
